import { useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import store from "../store";

const generateShareLink = () => {

    console.log("generate share link");

    const { origin } = window.location;

    const backupData = store.getState()["visualizer"];


    var shareLink = origin + "/shared/";

    var mydata = {
        backup : backupData
    }; 

    const shareData = {
        specifier:'spec',
        sel:'sel',
        url:shareLink,
        message:"Check out this design I made using the Mannington Visualizer!"
    }

    // Avoid calling for actual lizard proxy if its
    if(origin.indexOf("localhost") === -1){
        return new Promise(function (resolve, reject) {
            window.IMWC.lizard.getShortener(shareLink, "Mannington", JSON.stringify(mydata), '{}').then(function (r) {
            var arr = r.data.shortUrl.split('/');
            shareData["url"] = shareLink + arr[arr.length - 1];
            console.log(shareData);
            resolve(shareData);
            });
        });
    }
    else{
        return new Promise(function (resolve, reject) {
            resolve(shareData);
        });
    }
}

const loadShareLink = (code) => {
    if(origin.indexOf("localhost") === -1){
        return new Promise(function (resolve, reject) {
            window.IMWC.lizard.getShortenerData(code).then(function(r) {
                resolve(r.data)
            })
        });
    }
    else{
        return new Promise(function (resolve, reject) {
            resolve("");
        });
    }
}

export {generateShareLink, loadShareLink}

